module.exports = __webpack_public_path__ + "static/img/training_system_hy_s1.2f30e9a5.png";